import React, {useRef, useState} from 'react'
import Window from "../gui/window";
import FnBox from "./fnbox";
import DriveBox from "./drivebox";
import {setGuiState} from "../../data/actions";
import {connect, useDispatch} from "react-redux";
import LcInfo from "./lc_info";

const LcControl = ({lc, gs}) => {
    const dispatch = useDispatch()

    const [showcv, setshowcv] = useState(false)

    function lcClick() {
        dispatch(setGuiState({
            id: lc.id,
            show: !gs.show,
        }))
    }

    const wid = 240

    return (
        <Window close={lcClick} headline={lc.id} id={lc.id} width={wid}>
            <div
                style={{
                    color: "#000000",
                    display: 'inline',
                    position: 'absolute',
                    background: '#b8c2bc',
                }}
            >
                {showcv?<LcInfo lc={lc}/>:null}
                <FnBox lc={lc} width={wid} showcv={showcv} setshowcv={setshowcv} />
                <DriveBox lc={lc} width={wid}/>
            </div>
        </Window>
    )
}

const mapStateToProps = ((state, other) => {

    const itm = state.plan.items.find((itm) => {
        return itm.id === other.lc.id
    }) || {}

    const gitm = state.root.gui_state.find((itm) => {
        return itm.id === other.lc.id
    }) || {}

    return {lc: itm, gs: gitm}
})

export default connect(mapStateToProps)(LcControl)

